import maplibregl from "maplibre-gl";
import * as pmtiles from "pmtiles";
import "maplibre-gl/dist/maplibre-gl.css";


// On document ready with vanilla JS
document.addEventListener('DOMContentLoaded', function () {
    // If element with ID 'map' exists
    if (document.querySelector('.slider .google-map-top-space #map-canvas')) {
        // Initialize Map Libre JS
        const mapElement = document.querySelector('.slider .google-map-top-space #map-canvas');
        const tilesUrl = mapElement.getAttribute('data-tiles-url');
        const mapMarkerColorCode = mapElement.getAttribute('data-map-marker-color-code');
        const forceDefaultMarker = mapElement.getAttribute('data-force-default-map-marker') === 'true';
        const lat = parseFloat(mapElement.getAttribute('data-latitude'));
        const lng = parseFloat(mapElement.getAttribute('data-longitude'));
        const zoom = parseInt(mapElement.getAttribute('data-zoom'));

        const protocol = new pmtiles.Protocol();
        maplibregl.addProtocol("pmtiles", protocol.tile);

        const source = new pmtiles.PMTiles(tilesUrl);
        protocol.add(source);


        const map = new maplibregl.Map({
            container: 'map-canvas',
            style: map_style,
            center: [lng, lat],
            zoom: zoom,
            attributionControl: false
        });


        map.addControl(new maplibregl.AttributionControl(), 'top-right');

        // Add marker to map
        const imageUrl = templateurl + '/assets/map-marker-neu.png';

        if (forceDefaultMarker) {
            // If mapMarkerColorCode is set, change the color of the default marker
            if (mapMarkerColorCode) {
                const marker = new maplibregl.Marker({
                    color: mapMarkerColorCode,
                })
                    .setLngLat([lng, lat]).addTo(map);
            } else {
                const marker = new maplibregl.Marker()
                    .setLngLat([lng, lat]).addTo(map);
            }

        } else {
            // Create a DOM element for the marker
            const el = document.createElement('div');
            el.className = 'custom-marker';
            el.style.backgroundImage = `url(${imageUrl})`;
            el.style.width = '74px';
            el.style.height = '98px';
            el.style.backgroundSize = '100%';

            // Add marker to map
            const marker = new maplibregl.Marker({
                element: el,
                anchor: 'bottom'
            })
                .setLngLat([lng, lat])
                .addTo(map);
        }
    }
});